'use client'
import { differenceInMinutes } from 'date-fns'
import Link from 'next/link'
import { useTimer } from 'react-timer-hook'

import DateBox from '@/app/clinic/(defaultLayout)/(followup)/booking/[id]/_components/DateBox'
import { PrimaryButton } from '@/components/Buttons'

import { ConsultationStatus } from '../types'

const ConsultationLiveChild = ({
  status,
  start_time,
  end_time,
  consultationID,
}: {
  status: ConsultationStatus
  start_time: Date
  end_time: Date
  id: number
  consultationID: number
}) => {
  const parsedTime = start_time
  const diffInMinutes = differenceInMinutes(parsedTime, new Date())
  const { seconds, minutes } = useTimer({
    expiryTimestamp: parsedTime,
    autoStart: diffInMinutes >= 0 && diffInMinutes <= 5,
    onExpire: () => console.warn('onExpire called'),
  })

  return (
    <div
      className={`
       md:mx-9 mx-5 md:mb-7 mb-4 flex flex-col items-center justify-between md:gap-10 gap-4

        md:flex-row
      `}
    >
      {diffInMinutes <= 5 && minutes + seconds !== 0 && (
        <>
          Starts in{' '}
          {minutes.toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false,
          })}
          :
          {seconds.toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false,
          })}
        </>
      )}
      <DateBox
        date={start_time}
        time={[start_time, end_time]}
        className={`
          h-[84px] w-full flex-row items-center justify-between p-2 px-4 lg:max-w-[360px] border-2 border-[#D4D8E3]
        `}
        pageType='live'
      />
      <PrimaryButton
        as={Link}
        // as={"/meeting"}
        href={{ pathname: '/meeting', query: { consultationID } }}
        className='h-[40px] md:w-[120px] w-full rounded-md bg-[#2E9B32]'
      >
        {status === ConsultationStatus.Upcoming || status === ConsultationStatus.Awaiting ? 'Join' : 'Rejoin'}
      </PrimaryButton>
    </div>
  )
}

export default ConsultationLiveChild
